import { QuestionRoutes } from "./question.router";
import { USER_TYPES } from "../assets/variables";

export const DashboardRoutes = [
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    // 대시보드 기업회원 페이지 라우트
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 회사정보
        path: "/dashboard/company",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/CompanyPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 채용 - 목록
        path: "/dashboard/recruitments",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/RecruitmentListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 채용 - 모집현황
        path: "/dashboard/recruitments/:_recruitment/kanban",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/RecruitmentKanbanPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 채용 - 합격자
        path: "/dashboard/recruitments/:_recruitment/recruits",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/RecruitmentRecruitList.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 미팅 - 목록
        path: "/dashboard/meetings",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/MeetingListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 비대면면접 - 목록
        path: "/dashboard/interviews",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/InterviewListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 교육서비스 - 목록
        path: "/dashboard/lectures",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/LectureListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 마이인재풀 - 목록
        path: "/dashboard/human-resource",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/HumanResourceList.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 근로자 계약서 - 목록
        path: "/dashboard/employment-forms",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/EmploymentFormList.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 근무자 현황 - 목록
        path: "/dashboard/worker",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/WorkerListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 근무자 현황 - 목록
        path: "/dashboard/worker/personal/:contract",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/WorkerPersonalStatusPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 근무자 현황 - 목록
        path: "/dashboard/worker/company/:place",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/WorkerCompanyStatusPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 미팅 - 목록
        path: "/dashboard/human-resource/:tab",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/HumanResourceList.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 포인트
        path: "/dashboard/point",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/PointListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },
    {
        // 포인트
        path: "/dashboard/point/:tab",
        component: () => import(/* webpackChunkName: "dashboard-company" */ "../pages/dashboard/company/PointListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.COMPANY.value],
    },

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    // 대시보드 개인회원 페이지 라우트
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 이력서
        path: "/dashboard/resume",
        component: () => import(/* webpackChunkName: "dashboard-person" */ "../pages/dashboard/person/ResumePage.vue"),
        props: true,
        userTypes: [USER_TYPES.PERSON.value],
    },
    {
        // 이력서
        path: "/dashboard/records",
        component: () => import(/* webpackChunkName: "dashboard-person" */ "../pages/dashboard/person/RecordListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.PERSON.value],
    },
    {
        // 찜한공고
        path: "/dashboard/watching",
        component: () => import(/* webpackChunkName: "dashboard-person" */ "../pages/dashboard/person/WatchingListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.PERSON.value],
    },
    {
        // 찜한공고
        path: "/dashboard/companies",
        component: () => import(/* webpackChunkName: "dashboard-person" */ "../pages/dashboard/person/CompanyListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.PERSON.value],
    },
    {
        // 지원현황
        path: "/dashboard/applied",
        component: () => import(/* webpackChunkName: "dashboard-person" */ "../pages/dashboard/person/AppliedListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.PERSON.value],
    },
    {
        // 미팅 - 목록
        path: "/dashboard/schedules",
        component: () => import(/* webpackChunkName: "dashboard-person" */ "../pages/dashboard/person/ScheduleListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.PERSON.value],
    },
    {
        // 비대면면접 - 접근
        path: "/dashboard/interview",
        component: () => import(/* webpackChunkName: "dashboard-person" */ "../pages/dashboard/person/InterviewViewPage.vue"),
        props: true,
        userTypes: [USER_TYPES.PERSON.value],
    },
    {
        // 근로자 계약서 관리
        path: "/dashboard/employment-contract",
        component: () => import(/* webpackChunkName: "dashboard-person" */ "../pages/dashboard/person/EmploymentContractListPage.vue"),
        props: true,
        userTypes: [USER_TYPES.PERSON.value],
    },

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    // 대시보드 공통 페이지 라우트
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 1:1 문의
        path: "/dashboard/queries",
        component: () => import(/* webpackChunkName: "dashboard-queries" */ "../pages/dashboard/common/QueryPage.vue"),
        children: [...QuestionRoutes],
        props: true,
        userTypes: [USER_TYPES.COMPANY.value, USER_TYPES.PERSON.value],
    },
    {
        // 1:1 문의
        path: "/dashboard/password",
        component: () => import(/* webpackChunkName: "dashboard-queries" */ "../pages/dashboard/common/FindPwPage.vue"),
        children: [...QuestionRoutes],
        props: true,
        userTypes: [USER_TYPES.COMPANY.value, USER_TYPES.PERSON.value],
    },
];
